'use client'
import {
  context_default,
  useSearch
} from "./chunk-WOKBAUXU.mjs";
import {
  SYMBOLS
} from "./chunk-A4XRECLB.mjs";
import {
  IconItem_default,
  Location_default,
  Price_default,
  Sellers_default,
  Type_default
} from "./chunk-3RIFEIGI.mjs";
import {
  useConfig_default
} from "./chunk-ZSKGVFZ4.mjs";
import {
  ContentfulButton_default
} from "./chunk-N7S35DQG.mjs";
import {
  ThemeButton_default
} from "./chunk-VYWHMVWT.mjs";
import {
  DecoratedSection_default
} from "./chunk-THREBTTP.mjs";
import {
  ContentfulMedia_default
} from "./chunk-IOBZ5NBW.mjs";
import {
  useFavorites
} from "./chunk-BB4H5TUC.mjs";
import {
  context_default as context_default2,
  useItinerary
} from "./chunk-YBJOQHTL.mjs";
import {
  useFilterQuery_default
} from "./chunk-7GAGCG6W.mjs";
import {
  useGetWeatherCondition
} from "./chunk-F7HCPT4F.mjs";
import {
  useGetEventsList
} from "./chunk-TW33R6V4.mjs";
import {
  useGetCategories
} from "./chunk-HKGNX5TB.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/layout/Layout.tsx
import { Fragment as Fragment11, Suspense } from "react";
import { useRouter as useRouter21 } from "@wbk/config";

// src/context/search/provider.tsx
import { useRef, useState } from "react";
import { getItem, safeParseJson, setItem, splitDateTime } from "@wbk/utils";
import { useRouter } from "@wbk/config";
import { jsx } from "react/jsx-runtime";
var searchDefaultValues = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const category = searchParams.get("category") || "";
  const search = searchParams.get("search") || void 0;
  const dateFrom = searchParams.get("from");
  const dateTo = searchParams.get("to");
  const from = dateFrom ? new Date(dateFrom) : void 0;
  const to = dateTo ? new Date(dateTo) : void 0;
  const prevHistory = getItem("search_history") || "";
  const searchHistory = safeParseJson(prevHistory);
  return {
    category,
    searchHistory,
    search,
    searchState: "",
    from,
    to,
    showPopover: false
  };
};
var SearchProvider = ({ children }) => {
  const { locale, push } = useRouter();
  const [state, setState] = useState(searchDefaultValues());
  const timeoutRef = useRef(void 0);
  const canFetch = typeof state.search === "string";
  const { query } = useFilterQuery_default({
    state: {
      search: state.search || "",
      category: state.category || "",
      from: state.from,
      to: state.to,
      perPage: 10
    }
  });
  const { data: events, isFetching } = useGetEventsList(query, { enabled: canFetch });
  const togglePopover = (state2) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { showPopover: state2 }));
  };
  const onSearch = (val) => {
    const value = val || "";
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { searchState: value }));
    clearTimeout(timeoutRef.current);
    if (!val) {
      return setState((prevState) => __spreadProps(__spreadValues({}, prevState), { search: "" }));
    }
    timeoutRef.current = setTimeout(() => {
      saveSearch(value);
    }, 500);
  };
  const setCategory = (category) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { category: category || "" }));
  };
  const setDate = (from, to) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { from, to }));
  };
  const saveSearch = (value) => {
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { search: value }));
    if (value && value.length > 2) {
      const prevHistory = getItem("search_history");
      const history = prevHistory ? JSON.parse(prevHistory) : [];
      if (!(history == null ? void 0 : history.includes(value == null ? void 0 : value.trim()))) {
        const newHistory = history.concat(value).slice(-5);
        setState((prevState) => __spreadProps(__spreadValues({}, prevState), { searchHistory: newHistory }));
        setItem("search_history", JSON.stringify(newHistory));
      }
    }
  };
  const clearHistory = () => {
    localStorage.removeItem("search_history");
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { searchHistory: [] }));
  };
  const onSubmit = () => {
    var _a, _b, _c;
    const searchParams = new URLSearchParams();
    if (state.from) {
      const from = splitDateTime(state.from, "en", { month: "2-digit", day: "2-digit" }).date;
      searchParams.set("from", from);
    }
    if (state.to) {
      const to = splitDateTime(state.to, "en", { month: "2-digit", day: "2-digit" }).date;
      searchParams.set("to", to);
    }
    if (state.from && state.to) {
      searchParams.set("date", "custom");
    }
    if ((_a = state.searchState) == null ? void 0 : _a.trim()) {
      searchParams.set("search", (_b = state.searchState) == null ? void 0 : _b.trim());
    }
    if (state.category) {
      searchParams.set("category", state.category);
    }
    const dest = !((_c = state.searchState) == null ? void 0 : _c.trim()) ? "explore" : "search";
    togglePopover(false);
    push(`/${locale}/${dest}?${searchParams.toString()}`);
  };
  const clearAll = () => {
    setState((prev) => __spreadProps(__spreadValues({}, prev), {
      category: "",
      from: void 0,
      to: void 0,
      search: "",
      searchState: "",
      showPopover: false
    }));
  };
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        togglePopover,
        onSearch,
        setCategory,
        setDate,
        clearHistory,
        onSubmit,
        clearAll,
        isLoading: isFetching,
        events: events == null ? void 0 : events.items,
        total: events == null ? void 0 : events.total
      }),
      children
    }
  );
};
var provider_default = SearchProvider;

// src/components/layout/header/Desktop.tsx
import { useWindowScroll } from "@wbk/hooks";
import { twMerge as twMerge6 } from "tailwind-merge";
import { Link as Link7, useRouter as useRouter16 } from "@wbk/config";

// src/components/layout/header/submenu/index.tsx
import { useState as useState5 } from "react";
import { MapIcon, MapOutlinedIcon, WeatherIcon, WeatherOutlinedIcon } from "@wbk/svg";
import { Button as Button12, Popover as Popover2, Typography as Typography16 } from "@wbk/ui";
import { Link as Link6, useRouter as useRouter13, useTranslation as useTranslation17 } from "@wbk/config";

// src/components/common/LocalizationSwitcher.tsx
import { useCurrency } from "@wbk/currency";
import { Button, ResponsivePopover, ToggleGroup, Typography } from "@wbk/ui";
import { WorldIcon, WorldOutlinedIcon } from "@wbk/svg";
import { useRouter as useRouter2, useTranslation } from "@wbk/config";
import { twMerge } from "tailwind-merge";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var LocalizationSwitcher = ({ render }) => {
  const { t } = useTranslation("calendar_common");
  return /* @__PURE__ */ jsx2(
    ResponsivePopover,
    {
      popover: {
        className: "w-[560px] max-w-full",
        align: "end",
        sideOffset: 35,
        alignOffset: -15,
        action: false,
        cancel: false
      },
      sheet: {
        ignoreHistory: true,
        action: false,
        cancel: false
      },
      render: (props) => {
        if (render) {
          return render(props);
        }
        return /* @__PURE__ */ jsxs(
          Button,
          {
            shape: "text",
            theme: "secondary",
            className: "group peer bg-transparent px-2",
            onClick: props.open,
            "aria-label": t("calendar_common:language"),
            children: [
              /* @__PURE__ */ jsx2(
                WorldOutlinedIcon,
                {
                  "data-active": props.isOpen,
                  className: "h-6 w-6 shrink-0 data-[active=true]:hidden"
                }
              ),
              /* @__PURE__ */ jsx2(
                WorldIcon,
                {
                  "data-active": props.isOpen,
                  className: "hidden h-6 w-6 shrink-0 data-[active=true]:block"
                }
              )
            ]
          }
        );
      },
      body: ({ close }) => /* @__PURE__ */ jsx2(Body, { close })
    }
  );
};
var Body = ({ close, className }) => {
  const { locale, setLocale, languages } = useRouter2();
  const { currency, setCurrency, currencies } = useCurrency();
  const { t } = useTranslation("calendar_common");
  return /* @__PURE__ */ jsxs("div", { className: twMerge("w-full space-y-4", className), children: [
    /* @__PURE__ */ jsx2(
      ToggleGroup,
      {
        type: "single",
        value: locale,
        label: /* @__PURE__ */ jsx2(Typography, { variant: "body-L", strong: true, children: t("calendar_common:language") }),
        options: [
          ...languages.map((lang) => ({
            text: t(`common:${lang}`),
            value: lang,
            isSelected: locale === lang
          })),
          {
            text: t("common:zh_coming_soon"),
            value: "zh",
            disabled: true
          }
        ],
        onChange: (val) => __async(void 0, null, function* () {
          if (val && val !== locale) {
            yield setLocale(val);
            close();
          }
        }),
        groupClassName: "gap-4 grid grid-cols-2",
        className: "justify-start text-start",
        btnProps: {
          shape: "outlined",
          theme: "primary",
          className: "border border-input-border text-text max-w-full"
        },
        activeBtnProps: { shape: "outlined", className: "bg-primary/5 text-text max-w-full" }
      }
    ),
    currencies && /* @__PURE__ */ jsx2(
      ToggleGroup,
      {
        type: "single",
        value: currency.shortCode,
        label: /* @__PURE__ */ jsx2(Typography, { variant: "body-L", strong: true, children: t("calendar_common:currency") }),
        options: currencies.map((currency2) => {
          const code = currency2.shortCode;
          const countryCode = code.slice(0, 2);
          return {
            icon: /* @__PURE__ */ jsx2(
              "img",
              {
                className: "h-6 w-6 shrink-0 rounded-full",
                src: `https://wbk-assets.s3.me-south-1.amazonaws.com/flags/w80/${countryCode.toLowerCase()}.png`,
                alt: ""
              }
            ),
            text: /* @__PURE__ */ jsx2(Typography, { className: "line-clamp-1", children: currency2.name }),
            value: code,
            isSelected: currency2.shortCode === code
          };
        }),
        onChange: (val) => {
          if (val && val !== currency.shortCode) {
            setCurrency(val);
            close();
          }
        },
        groupClassName: "gap-4 grid grid-cols-2",
        className: "justify-start text-start",
        btnProps: {
          shape: "outlined",
          theme: "primary",
          className: "border border-input-border text-text max-w-full"
        },
        activeBtnProps: {
          shape: "outlined",
          className: "bg-primary/5 text-text max-w-full"
        }
      }
    )
  ] });
};
var LocalizationSwitcher_default = LocalizationSwitcher;

// src/components/weather/Weather.tsx
import { useState as useState2 } from "react";
import { Button as Button2, Divider, Typography as Typography3 } from "@wbk/ui";
import { formatDate } from "@wbk/utils";
import { Link, useRouter as useRouter3, useTranslation as useTranslation2 } from "@wbk/config";
import { twMerge as twMerge2 } from "tailwind-merge";

// src/components/weather/Info.tsx
import { ArrowIcon } from "@wbk/svg";
import { ImageWithFallback, Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var WeatherInfo = ({ data, unit }) => {
  if (!data) {
    return null;
  }
  return /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsx3(
      ImageWithFallback,
      {
        src: `/@wbk/calendar/icons/forecast/${data.WeatherIcon}.png`,
        alt: data.WeatherText,
        className: "h-10 w-20 md:h-14 md:w-24"
      }
    ),
    /* @__PURE__ */ jsxs2("div", { className: "grow space-y-1", children: [
      /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx3("div", { className: "flex items-center gap-px", children: /* @__PURE__ */ jsxs2(Typography2, { variant: "label-L", dir: "ltr", children: [
          /* @__PURE__ */ jsx3(ArrowIcon, { className: "inline h-5 w-5 rotate-90" }),
          /* @__PURE__ */ jsx3("span", { children: data.TemperatureSummary.Past6HourRange.Maximum[unit].Value }),
          /* @__PURE__ */ jsx3("span", { children: SYMBOLS[unit] })
        ] }) }),
        /* @__PURE__ */ jsx3("div", { className: "flex items-center gap-px", children: /* @__PURE__ */ jsxs2(Typography2, { variant: "label-L", dir: "ltr", children: [
          /* @__PURE__ */ jsx3(ArrowIcon, { className: "inline h-5 w-5 -rotate-90" }),
          /* @__PURE__ */ jsx3("span", { children: data.TemperatureSummary.Past6HourRange.Minimum[unit].Value }),
          /* @__PURE__ */ jsx3("span", { children: SYMBOLS[unit] })
        ] }) })
      ] }),
      /* @__PURE__ */ jsx3(Typography2, { variant: "body-L", children: data.WeatherText })
    ] }),
    /* @__PURE__ */ jsxs2(Typography2, { variant: "heading-XXL", className: "flex", dir: "ltr", children: [
      data.Temperature[unit].Value,
      /* @__PURE__ */ jsx3("span", { className: "text-heading-S", children: SYMBOLS[unit] })
    ] })
  ] });
};
var Info_default = WeatherInfo;

// src/components/weather/Weather.tsx
import { Fragment, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Weather = ({ className, type = "full", onClick }) => {
  const { locale } = useRouter3();
  const { t } = useTranslation2("calendar_common");
  const { city } = useConfig_default();
  const [unit, setUnit] = useState2("Metric");
  const { data, isLoading } = useGetWeatherCondition({ lang: locale, city: city.slug });
  if (!data) {
  }
  if (type === "mini") {
    return /* @__PURE__ */ jsx4(Info_default, { data, unit });
  }
  if (type === "degree") {
    return /* @__PURE__ */ jsxs3(Fragment, { children: [
      /* @__PURE__ */ jsx4("span", { children: data ? data.TemperatureSummary.Past6HourRange.Minimum[unit].Value.toFixed(0) : "00" }),
      /* @__PURE__ */ jsxs3("span", { children: [
        " ",
        SYMBOLS[unit]
      ] })
    ] });
  }
  return isLoading ? /* @__PURE__ */ jsxs3("div", { className: twMerge2("space-y-4", className), children: [
    /* @__PURE__ */ jsx4("div", { className: "bg-body-level-1 h-10 animate-pulse" }),
    /* @__PURE__ */ jsx4("div", { className: "bg-body-level-1 h-10 animate-pulse" }),
    /* @__PURE__ */ jsx4(Divider, {}),
    /* @__PURE__ */ jsx4("div", { className: "bg-body-level-1 h-10 animate-pulse" })
  ] }) : data ? /* @__PURE__ */ jsxs3("div", { className: twMerge2("space-y-4", className), children: [
    /* @__PURE__ */ jsxs3("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsx4(Typography3, { variant: "body-L", children: formatDate(data.LocalObservationDateTime, locale, {
        dateStyle: "long",
        timeStyle: "short"
      }) }),
      /* @__PURE__ */ jsxs3("div", { className: "flex", children: [
        /* @__PURE__ */ jsx4(
          Button2,
          {
            shape: "text",
            className: "px-2 opacity-50 aria-pressed:opacity-100",
            onClick: () => setUnit("Metric"),
            "aria-pressed": unit === "Metric",
            children: /* @__PURE__ */ jsx4(Typography3, { variant: "heading-M", dir: "ltr", children: "\xB0C" })
          }
        ),
        /* @__PURE__ */ jsx4(
          Button2,
          {
            shape: "text",
            className: "px-2 opacity-50 aria-pressed:opacity-100",
            onClick: () => setUnit("Imperial"),
            "aria-pressed": unit === "Imperial",
            children: /* @__PURE__ */ jsx4(Typography3, { variant: "heading-M", dir: "ltr", children: "\xB0F" })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx4(Info_default, { data, unit }),
    /* @__PURE__ */ jsx4(Divider, {}),
    /* @__PURE__ */ jsx4(
      Button2,
      {
        as: Link,
        to: `/${locale}/weather`,
        shape: "text",
        className: "w-full justify-start text-start",
        onClick,
        arrow: true,
        children: /* @__PURE__ */ jsx4(Typography3, { strong: true, children: t("calendar_common:weather.view_events") })
      }
    )
  ] }) : null;
};
var Weather_default = Weather;

// src/components/favorites/FavoritesNav.tsx
import { useState as useState4 } from "react";
import { BottomSheet, Button as Button7, Popover } from "@wbk/ui";
import { Heart as Heart2, HeartOutlined } from "@wbk/svg";
import { useDeviceDetect } from "@wbk/hooks";
import { useTranslation as useTranslation7 } from "@wbk/config";

// src/components/favorites/FavoritesNavBody.tsx
import { Tabs, Typography as Typography8 } from "@wbk/ui";
import { useTranslation as useTranslation6 } from "@wbk/config";

// src/context/itinerary/provider.tsx
import { useEffect, useState as useState3 } from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var searchTimeout;
var createDefaultItinerary = () => {
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const from = new Date(currentYear, 0, 1);
  const to = new Date(currentYear, 11, 31);
  const days = [];
  const currentDate = new Date(from);
  while (currentDate <= to) {
    days.push({
      id: new Date(currentDate),
      events: []
    });
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return {
    id: `default-year-${currentYear}`,
    name: `${currentYear} Itinerary`,
    date: { from, to },
    days,
    created_at: /* @__PURE__ */ new Date()
  };
};
var ItineraryProvider = ({ children, id }) => {
  const [state, setState] = useState3({
    search: "",
    selectedEvents: []
  });
  const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
  const [itineraries, setItineraries] = useState3(() => {
    const stored = localStorage.getItem("itineraries");
    if (!stored || !stored.includes(`default-year-${currentYear}`)) {
      const defaultItinerary = createDefaultItinerary();
      const existingItineraries = stored ? JSON.parse(stored) : [];
      const updatedItineraries = [defaultItinerary, ...existingItineraries];
      localStorage.setItem("itineraries", JSON.stringify(updatedItineraries));
      return updatedItineraries;
    }
    const parsed = JSON.parse(stored);
    return parsed.map((itinerary) => {
      var _a;
      return __spreadProps(__spreadValues({}, itinerary), {
        date: {
          from: new Date(itinerary.date.from),
          to: new Date(itinerary.date.to)
        },
        days: (_a = itinerary.days) == null ? void 0 : _a.map((day) => __spreadProps(__spreadValues({}, day), {
          id: new Date(day.id)
        }))
      });
    });
  });
  const [mode, setMode] = useState3("summary");
  const [activeDay, setActiveDay] = useState3(null);
  const saveToLocalStorage = (updatedItineraries) => {
    setItineraries(updatedItineraries);
    localStorage.setItem("itineraries", JSON.stringify(updatedItineraries));
  };
  const addItinerary = (newItinerary) => {
    const newEntry = __spreadProps(__spreadValues({}, newItinerary), {
      created_at: /* @__PURE__ */ new Date()
    });
    const updatedItineraries = [...itineraries, newEntry];
    saveToLocalStorage(updatedItineraries);
  };
  const getItinerary = (id2) => {
    return itineraries.find((itinerary) => itinerary.id === id2);
  };
  const deleteItinerary = (id2) => {
    const updatedItineraries = itineraries.filter((itinerary) => itinerary.id !== id2);
    saveToLocalStorage(updatedItineraries);
  };
  const toggleEventSelection = (itineraryId, dayId, eventSlug) => {
    var _a;
    const isSelectedInTemp = state.selectedEvents.includes(eventSlug);
    const itinerary = getItinerary(itineraryId);
    const day = (_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.find((day2) => day2.id.toISOString() === dayId.toISOString());
    const isInStorage = day == null ? void 0 : day.events.some((slug) => slug === eventSlug);
    if (isSelectedInTemp || isInStorage) {
      setState((prev) => __spreadProps(__spreadValues({}, prev), {
        selectedEvents: prev.selectedEvents.filter((slug) => slug !== eventSlug)
      }));
      if (isInStorage) {
        const updatedItineraries = itineraries.map((itinerary2) => {
          var _a2;
          if (itinerary2.id !== itineraryId)
            return itinerary2;
          return __spreadProps(__spreadValues({}, itinerary2), {
            days: (_a2 = itinerary2.days) == null ? void 0 : _a2.map((day2) => {
              if (day2.id.toISOString() !== dayId.toISOString())
                return day2;
              return __spreadProps(__spreadValues({}, day2), {
                events: day2.events.filter((slug) => slug !== eventSlug)
              });
            })
          });
        });
        saveToLocalStorage(updatedItineraries);
      }
    } else {
      setState((prev) => __spreadProps(__spreadValues({}, prev), { selectedEvents: [...prev.selectedEvents, eventSlug] }));
    }
  };
  const cancelSelection = () => {
    setState((prev) => __spreadProps(__spreadValues({}, prev), { selectedEvents: [] }));
  };
  const confirmSelection = (itineraryId, dayId) => {
    const updatedList = itineraries.map((itinerary) => {
      var _a;
      if (itinerary.id !== itineraryId)
        return itinerary;
      return __spreadProps(__spreadValues({}, itinerary), {
        days: (_a = itinerary.days) == null ? void 0 : _a.map((day) => {
          if (day.id.toISOString() !== dayId.toISOString())
            return day;
          return __spreadProps(__spreadValues({}, day), {
            events: [.../* @__PURE__ */ new Set([...day.events, ...state.selectedEvents])]
            // Avoid duplicates
          });
        })
      });
    });
    saveToLocalStorage(updatedList);
    setState((prev) => __spreadProps(__spreadValues({}, prev), { selectedEvents: [] }));
  };
  const handleSearch = (value) => {
    const searchValue = value || "";
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      setState((prev) => __spreadProps(__spreadValues({}, prev), { search: searchValue }));
    }, 500);
  };
  const isEventInDay = (itineraryId, dayId, eventSlug) => {
    var _a;
    const itinerary = getItinerary(itineraryId);
    const day = (_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.find((day2) => day2.id.toISOString() === dayId.toISOString());
    return state.selectedEvents.includes(eventSlug) || !!(day == null ? void 0 : day.events.some((slug) => slug === eventSlug));
  };
  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  };
  const updateItinerary = (id2, updatedData) => {
    const itinerary = itineraries.find((itinerary2) => itinerary2.id === id2);
    if (!itinerary)
      return;
    const { name, date } = updatedData;
    const oldDays = itinerary.days || [];
    const newDays = [];
    if (date) {
      const currentDate = normalizeDate(new Date(date.from));
      while (currentDate <= date.to) {
        const existingDay = oldDays.find(
          (day) => normalizeDate(day.id).toISOString() === currentDate.toISOString()
        );
        newDays.push(
          existingDay || {
            id: normalizeDate(new Date(currentDate)),
            events: []
          }
        );
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }
    const updatedItinerary = __spreadProps(__spreadValues({}, itinerary), {
      name: name || itinerary.name,
      date: date || itinerary.date,
      days: newDays
    });
    const updatedList = itineraries.map(
      (itinerary2) => itinerary2.id === id2 ? updatedItinerary : itinerary2
    );
    saveToLocalStorage(updatedList);
  };
  const reorderEvents = (itineraryId, updates) => {
    var _a;
    const itinerary = itineraries.find((i) => i.id === itineraryId);
    if (!itinerary)
      return;
    const updatedDays = (_a = itinerary.days) == null ? void 0 : _a.map(
      (day) => updates[day.id.toISOString()] ? __spreadProps(__spreadValues({}, day), { events: updates[day.id.toISOString()] }) : day
    );
    const updatedItinerary = __spreadProps(__spreadValues({}, itinerary), { days: updatedDays });
    saveToLocalStorage(itineraries.map((i) => i.id === itineraryId ? updatedItinerary : i));
  };
  useEffect(() => {
    const now = /* @__PURE__ */ new Date();
    const sixMonthsAgo = /* @__PURE__ */ new Date();
    sixMonthsAgo.setMonth(now.getMonth() - 6);
    const cleanedItineraries = itineraries.filter((itinerary) => {
      var _a;
      const notOld = new Date(itinerary.created_at) > sixMonthsAgo;
      const hasEvents = !!((_a = itinerary.days) == null ? void 0 : _a.length);
      return notOld && hasEvents;
    });
    saveToLocalStorage(cleanedItineraries);
  }, []);
  return /* @__PURE__ */ jsx5(
    context_default2.Provider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        id,
        itineraries,
        addItinerary,
        getItinerary,
        deleteItinerary,
        mode,
        setMode,
        activeDay,
        setActiveDay,
        handleSearch,
        toggleEventSelection,
        cancelSelection,
        confirmSelection,
        isEventInDay,
        updateItinerary,
        reorderEvents
      }),
      children
    }
  );
};
var provider_default2 = ItineraryProvider;

// src/components/favorites/FavoritesContent.tsx
import { Button as Button4, Typography as Typography5 } from "@wbk/ui";
import { ArrowIcon as ArrowIcon2, BrokenHeart } from "@wbk/svg";
import { Link as Link3, useRouter as useRouter5, useTranslation as useTranslation4 } from "@wbk/config";

// src/components/events/card/ListItem.tsx
import { Button as Button3, Typography as Typography4 } from "@wbk/ui";
import { Link as Link2, useRouter as useRouter4, useTranslation as useTranslation3 } from "@wbk/config";
import { twMerge as twMerge3 } from "tailwind-merge";
import { Heart } from "@wbk/svg";
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var EventListItem = ({ event, className, onClick }) => {
  const { t } = useTranslation3("calendar_common");
  const { locale } = useRouter4();
  const { toggleFavorite, isFavorite } = useFavorites();
  const isFaved = isFavorite(event.slug);
  return /* @__PURE__ */ jsxs4(
    Button3,
    {
      "data-testid": `item_${event.slug}`,
      href: `/${locale}/${event.category.slug}/${event.slug}`,
      as: Link2,
      className: twMerge3("relative w-full justify-start gap-3 p-0 text-start", className),
      theme: "transparent",
      onClick,
      children: [
        /* @__PURE__ */ jsx6(
          ContentfulMedia_default,
          {
            className: "rtl:rounded-r-S ltr:rounded-l-S h-full shrink-0 object-cover",
            media: event.image11,
            width: 140,
            height: 140,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          }
        ),
        /* @__PURE__ */ jsxs4("div", { className: "grow space-y-0.5 py-2 [&>div:nth-child(1)]:text-xs [&>div:nth-child(3)]:text-sm", children: [
          /* @__PURE__ */ jsxs4("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ jsx6(Type_default, { event, className: "grow" }),
            /* @__PURE__ */ jsx6(
              Button3,
              {
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleFavorite(event.slug, event.title);
                },
                className: "hover:bg-body/10 shrink-0 rounded-full p-0 ltr:mr-2 rtl:ml-2",
                shape: "text",
                "aria-label": isFaved ? t("calendar_common:favorites.remove") : t("calendar_common:favorites.add"),
                children: isFaved ? /* @__PURE__ */ jsx6(Heart, { className: "text-error stroke-body-light h-4 w-4 object-contain md:h-5 md:w-5" }) : /* @__PURE__ */ jsx6(Heart, { className: "stroke-body-dark text-body-light h-4 w-4 object-contain md:h-5 md:w-5" })
              }
            )
          ] }),
          /* @__PURE__ */ jsx6(Typography4, { variant: "heading-XS", className: "line-clamp-2", children: event.title }),
          /* @__PURE__ */ jsx6(Location_default, { location: event.location, className: "text-text-secondary" }),
          /* @__PURE__ */ jsx6(Price_default, { event }),
          /* @__PURE__ */ jsx6(Sellers_default, { sellers: event.sellersCollection, link: false })
        ] })
      ]
    }
  );
};
var ListItem_default = EventListItem;

// src/components/favorites/FavoritesContent.tsx
import { Fragment as Fragment2, jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var FavoritesContent = ({ close }) => {
  const { locale } = useRouter5();
  const { t } = useTranslation4("calendar_common");
  const { favorites } = useFavorites();
  const { data, isLoading, error } = useGetEventsList({
    lang: locale,
    where: { slug_in: favorites },
    limit: 3
  });
  if (error) {
    return null;
  }
  return /* @__PURE__ */ jsxs5(Fragment2, { children: [
    /* @__PURE__ */ jsx7("div", { className: "space-y-2 p-4", children: isLoading ? /* @__PURE__ */ jsxs5(Fragment2, { children: [
      /* @__PURE__ */ jsx7("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx7("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx7("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" })
    ] }) : data && (data == null ? void 0 : data.items.length) > 0 ? data == null ? void 0 : data.items.map((event) => /* @__PURE__ */ jsx7(ListItem_default, { event, onClick: close }, event.id)) : /* @__PURE__ */ jsxs5("div", { className: "flex w-full flex-col items-center justify-center gap-5 pb-10 pt-5 text-center", children: [
      /* @__PURE__ */ jsx7(BrokenHeart, { className: "bg-body-level-2 text-primary h-14 w-14 rounded-full p-2" }),
      /* @__PURE__ */ jsxs5("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx7(Typography5, { variant: "label-L", children: t("calendar_common:favorites.empty") }),
        /* @__PURE__ */ jsx7(Typography5, { variant: "body-S", color: "text-secondary", children: t("calendar_common:favorites.how_to_add_favorites_description") })
      ] }),
      /* @__PURE__ */ jsx7(ThemeButton_default, { as: Link3, to: `/${locale}/explore`, onClick: close, children: t("calendar_common:favorites.explore_more") })
    ] }) }),
    /* @__PURE__ */ jsx7(ActionButton, { onClick: close })
  ] });
};
var ActionButton = ({ onClick }) => {
  const { favorites } = useFavorites();
  const { locale } = useRouter5();
  const { t } = useTranslation4("calendar_common");
  return /* @__PURE__ */ jsx7(
    Button4,
    {
      as: Link3,
      to: `/${locale}/favorites`,
      shape: "text",
      className: "border-paper text-text bg-body-level-1 hover:bg-body-level-2 w-full justify-start rounded-none border-t p-4 text-start",
      onClick,
      children: /* @__PURE__ */ jsxs5("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx7(Typography5, { strong: true, children: t("calendar_common:favorites.open_favorites_total", { count: favorites.length }) }),
        /* @__PURE__ */ jsx7(ArrowIcon2, { className: "ltr:rotate-180" })
      ] })
    }
  );
};
var FavoritesContent_default = FavoritesContent;

// src/components/favorites/ItineraryContent.tsx
import { Button as Button6, Typography as Typography7 } from "@wbk/ui";
import { Link as Link5, useRouter as useRouter7, useTranslation as useTranslation5 } from "@wbk/config";
import { ArrowIcon as ArrowIcon3, BrokenHeart as BrokenHeart2 } from "@wbk/svg";

// src/components/itinerary/ListItem.tsx
import { twMerge as twMerge4 } from "tailwind-merge";
import { Link as Link4, useRouter as useRouter6 } from "@wbk/config";
import { Button as Button5, ImageWithPlaceholder, Typography as Typography6 } from "@wbk/ui";
import { formatDate as formatDate2 } from "@wbk/utils";
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var ItineraryListItem = ({ events, itinerary, onClick }) => {
  var _a;
  const { locale } = useRouter6();
  return /* @__PURE__ */ jsxs6(
    Button5,
    {
      href: `/${locale}/itinerary/view/${itinerary.id}`,
      as: Link4,
      className: twMerge4("text-text flex w-full items-center gap-3 bg-transparent p-0 text-start"),
      shape: "text",
      "data-testid": `itinerary_list_item_${itinerary.id}`,
      onClick,
      children: [
        /* @__PURE__ */ jsx8("div", { className: "aspect-1 rounded-S h-[120px] w-full max-w-[120px] overflow-hidden", children: !events.length ? /* @__PURE__ */ jsx8(ImageWithPlaceholder, { className: "aspect-1", width: 120, height: 120 }) : events.length >= 4 ? /* @__PURE__ */ jsx8("div", { className: "grid grid-cols-2", children: events.slice(0, 4).map((event, i) => /* @__PURE__ */ jsx8(
          ContentfulMedia_default,
          {
            className: "aspect-1 h-full w-full shrink-0 object-cover",
            media: event.image11,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          },
          i
        )) }) : /* @__PURE__ */ jsx8(
          ContentfulMedia_default,
          {
            className: "aspect-1 h-[120px] w-[120px] shrink-0 object-cover",
            media: events[0].image11,
            width: 120,
            height: 120,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          }
        ) }),
        /* @__PURE__ */ jsxs6("div", { className: "w-full space-y-1 py-1", children: [
          /* @__PURE__ */ jsx8("div", { className: "flex items-start justify-between", children: /* @__PURE__ */ jsx8(Typography6, { variant: "label-M", className: "line-clamp-2 grow", children: itinerary.name }) }),
          itinerary.days && ((_a = itinerary.days) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsxs6(Typography6, { variant: "body-S", className: "text-text-secondary line-clamp-1", children: [
            formatDate2(itinerary.days[0].id, locale, {
              month: "short",
              day: "2-digit"
            }),
            /* @__PURE__ */ jsx8("span", { className: "px-2", children: "-" }),
            formatDate2(itinerary.days[itinerary.days.length - 1].id, locale, {
              month: "short",
              day: "2-digit"
            })
          ] })
        ] })
      ]
    }
  );
};
var ListItem_default2 = ItineraryListItem;

// src/components/favorites/ItineraryContent.tsx
import { Fragment as Fragment3, jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var ItineraryContent = ({ close }) => {
  const { locale } = useRouter7();
  const { t } = useTranslation5("calendar_common");
  const { itineraries } = useItinerary();
  const slugs = Array.from(
    new Set(itineraries.flatMap((itinerary) => {
      var _a;
      return ((_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.flatMap((day) => day.events)) || [];
    }))
  );
  const {
    data: events,
    isLoading,
    error
  } = useGetEventsList({
    lang: locale,
    where: { slug_in: slugs },
    limit: 50
  });
  const eventsByItinerary = itineraries.reduce(
    (acc, itinerary) => {
      var _a;
      const itineraryEvents = (_a = itinerary.days) == null ? void 0 : _a.flatMap(
        (day) => day.events.map((slug) => events == null ? void 0 : events.items.find((event) => event.slug === slug)).filter((event) => !!event)
      );
      acc[itinerary.id] = itineraryEvents || [];
      return acc;
    },
    {}
  );
  if (error) {
    return null;
  }
  return /* @__PURE__ */ jsxs7(Fragment3, { children: [
    /* @__PURE__ */ jsx9("div", { className: "space-y-2 p-4", children: isLoading ? /* @__PURE__ */ jsxs7(Fragment3, { children: [
      /* @__PURE__ */ jsx9("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx9("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx9("div", { className: "bg-body-level-2 h-[120px] animate-pulse rounded-md" })
    ] }) : itineraries && itineraries.length > 0 ? itineraries.slice(0, 3).map((item, i) => {
      const itineraryEvents = eventsByItinerary[item.id];
      return /* @__PURE__ */ jsx9("div", { className: "space-y-2", children: /* @__PURE__ */ jsx9(
        ListItem_default2,
        {
          itinerary: item,
          events: itineraryEvents.slice(0, 4),
          onClick: close
        }
      ) }, i);
    }) : /* @__PURE__ */ jsxs7("div", { className: "flex w-full flex-col items-center justify-center gap-5 pb-10 pt-5 text-center", children: [
      /* @__PURE__ */ jsx9(BrokenHeart2, { className: "bg-body-level-2 text-primary h-14 w-14 rounded-full p-2" }),
      /* @__PURE__ */ jsx9("div", { className: "space-y-1", children: /* @__PURE__ */ jsx9(Typography7, { variant: "label-L", children: t("calendar_common:itinerary.empty") }) }),
      /* @__PURE__ */ jsx9(ThemeButton_default, { as: Link5, to: `/${locale}/itinerary`, onClick: close, children: t("calendar_common:itinerary.add_itinerary") })
    ] }) }),
    /* @__PURE__ */ jsx9(ActionButton2, { onClick: close })
  ] });
};
var ActionButton2 = ({ onClick }) => {
  const { itineraries } = useItinerary();
  const { locale } = useRouter7();
  const { t } = useTranslation5("calendar_common");
  return /* @__PURE__ */ jsx9(
    Button6,
    {
      as: Link5,
      to: `/${locale}/favorites`,
      shape: "text",
      className: "border-paper text-text bg-body-level-1 hover:bg-body-level-2 w-full justify-start rounded-none border-t p-4 text-start",
      onClick,
      children: /* @__PURE__ */ jsxs7("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx9(Typography7, { strong: true, children: t("calendar_common:itinerary.open_itineraries_total", { count: itineraries.length }) }),
        /* @__PURE__ */ jsx9(ArrowIcon3, { className: "ltr:rotate-180" })
      ] })
    }
  );
};
var ItineraryContent_default = ItineraryContent;

// src/components/favorites/FavoritesNavBody.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var FavoritesNavBody = ({ close }) => {
  const { t } = useTranslation6("calendar_common");
  const tabs = [
    {
      label: /* @__PURE__ */ jsx10(Typography8, { variant: "body-L", strong: true, children: t("calendar_common:favorites.favorite") }),
      value: "favorite",
      content: /* @__PURE__ */ jsx10(FavoritesContent_default, { close }),
      buttonProps: {
        className: "p-4 data-[state=inactive]:border-paper text-primary data-[state=active]:border-primary data-[state=inactive]:text-text-secondary shrink-0"
      }
    },
    {
      label: /* @__PURE__ */ jsx10(Typography8, { variant: "body-L", strong: true, children: t("calendar_common:itinerary.trips") }),
      value: "trips",
      content: /* @__PURE__ */ jsx10(provider_default2, { children: /* @__PURE__ */ jsx10(ItineraryContent_default, { close }) }),
      buttonProps: {
        className: "p-4 data-[state=inactive]:border-paper text-primary data-[state=active]:border-primary data-[state=inactive]:text-text-secondary shrink-0"
      }
    }
  ];
  return /* @__PURE__ */ jsx10(Tabs, { className: "flex items-center", defaultValue: "favorite", tabs });
};
var FavoritesNavBody_default = FavoritesNavBody;

// src/components/favorites/FavoritesNav.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var FavoritesNav = ({ isActive }) => {
  const { t } = useTranslation7("calendar_common");
  const [open, setOpen] = useState4(false);
  const { isMobile } = useDeviceDetect();
  return !isActive && !isMobile ? /* @__PURE__ */ jsx11(
    Popover,
    {
      open,
      onOpenChange: setOpen,
      sideOffset: 35,
      alignOffset: -15,
      align: "end",
      className: "w-80 max-w-full overflow-hidden sm:w-[480px] [&>div]:p-0",
      content: /* @__PURE__ */ jsx11(FavoritesNavBody_default, { close: () => setOpen(false) }),
      children: /* @__PURE__ */ jsx11(
        Button7,
        {
          shape: "text",
          theme: "secondary",
          className: "peer px-2",
          "aria-label": t("calendar_common:favorites.title"),
          children: open ? /* @__PURE__ */ jsx11(Heart2, { "data-active": open, className: "h-6 w-6 shrink-0" }) : /* @__PURE__ */ jsx11(HeartOutlined, { className: "h-6 w-6 shrink-0" })
        }
      )
    }
  ) : !isActive && isMobile ? /* @__PURE__ */ jsx11(
    BottomSheet,
    {
      ignoreHistory: true,
      closeButton: true,
      className: "bg-body pb-2",
      render: ({ open: open2 }) => /* @__PURE__ */ jsx11(
        Button7,
        {
          onClick: open2,
          shape: "text",
          theme: "secondary",
          className: "peer px-2",
          "aria-label": t("calendar_common:favorites.title"),
          children: /* @__PURE__ */ jsx11(HeartOutlined, { className: "h-6 w-6 shrink-0" })
        }
      ),
      body: ({ close }) => /* @__PURE__ */ jsx11(FavoritesNavBody_default, { close })
    }
  ) : /* @__PURE__ */ jsx11(
    Button7,
    {
      shape: "text",
      theme: "secondary",
      className: "peer px-2",
      "aria-label": t("calendar_common:favorites.title"),
      children: /* @__PURE__ */ jsx11(Heart2, { className: "h-6 w-6 shrink-0" })
    }
  );
};
var FavoritesNav_default = FavoritesNav;

// src/components/layout/header/search/mobile/index.tsx
import { Button as Button11, Modal } from "@wbk/ui";
import { SearchIcon as SearchIcon3 } from "@wbk/svg";
import { useWindowResize } from "@wbk/hooks";
import { useTranslation as useTranslation15 } from "@wbk/config";

// src/components/layout/header/search/mobile/Content.tsx
import { Button as Button10, Input } from "@wbk/ui";
import { useRouter as useRouter11, useTranslation as useTranslation14 } from "@wbk/config";
import { ChevronIcon as ChevronIcon2, SearchIcon as SearchIcon2 } from "@wbk/svg";

// src/components/layout/header/search/desktop/Content.tsx
import { Typography as Typography12 } from "@wbk/ui";
import { useTranslation as useTranslation11 } from "@wbk/config";

// src/components/search/EmptyResult.tsx
import { useTranslation as useTranslation9 } from "@wbk/config";
import { SearchIcon } from "@wbk/svg";
import { Typography as Typography10 } from "@wbk/ui";

// src/components/search/FeaturedEvents.tsx
import { Typography as Typography9 } from "@wbk/ui";
import { useRouter as useRouter8, useTranslation as useTranslation8 } from "@wbk/config";
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var SearchFeaturedEvents = () => {
  const { togglePopover } = useSearch();
  const { t } = useTranslation8("calendar_common");
  const { locale } = useRouter8();
  const { data, isLoading } = useGetEventsList(
    {
      lang: locale,
      limit: 4,
      where: { featured: true }
    },
    { staleTime: Infinity }
  );
  const events = data == null ? void 0 : data.items;
  return /* @__PURE__ */ jsxs8("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsx12(Typography9, { variant: "heading-XS", children: t("calendar_common:most_searched") }),
    isLoading ? /* @__PURE__ */ jsxs8("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx12("div", { className: "bg-body-level-1 h-28 rounded-md" }),
      /* @__PURE__ */ jsx12("div", { className: "bg-body-level-1 h-28 rounded-md" }),
      /* @__PURE__ */ jsx12("div", { className: "bg-body-level-1 h-28 rounded-md" })
    ] }) : (events == null ? void 0 : events.length) ? /* @__PURE__ */ jsx12("ul", { className: "space-y-4", children: events == null ? void 0 : events.map((event, i) => /* @__PURE__ */ jsx12(
      "li",
      {
        className: "flex items-center gap-2 [&>a>img]:min-h-20 [&>a>img]:min-w-20",
        children: /* @__PURE__ */ jsx12(ListItem_default, { event, onClick: () => togglePopover(false) })
      },
      event.slug + i
    )) }) : null
  ] });
};
var FeaturedEvents_default = SearchFeaturedEvents;

// src/components/search/EmptyResult.tsx
import { Fragment as Fragment4, jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var EmptySearchResult = () => {
  const { t } = useTranslation9("calendar_common");
  const { searchState } = useSearch();
  return /* @__PURE__ */ jsxs9(Fragment4, { children: [
    /* @__PURE__ */ jsxs9("div", { className: "space-y-4", children: [
      /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 mx-auto flex h-20 w-20 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx13(SearchIcon, { className: "h-10 w-10 shrink-0" }) }),
      /* @__PURE__ */ jsxs9("div", { className: "space-y-1 text-center", children: [
        /* @__PURE__ */ jsx13(Typography10, { variant: "label-L", children: t("calendar_common:empty_search", { search: searchState }) }),
        /* @__PURE__ */ jsx13(Typography10, { variant: "body-S", color: "text-secondary", children: t("calendar_common:empty_search_description") })
      ] })
    ] }),
    /* @__PURE__ */ jsx13(FeaturedEvents_default, {})
  ] });
};
var EmptyResult_default = EmptySearchResult;

// src/components/search/InitialScreen.tsx
import { useTranslation as useTranslation10 } from "@wbk/config";
import { Divider as Divider2, Typography as Typography11 } from "@wbk/ui";
import { ArrowBackIcon } from "@wbk/svg";
import { Fragment as Fragment5, jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var SearchInitialScreen = () => {
  const { t } = useTranslation10("calendar_common");
  const { searchHistory, clearHistory, onSearch } = useSearch();
  return /* @__PURE__ */ jsxs10(Fragment5, { children: [
    searchHistory.length > 0 && /* @__PURE__ */ jsxs10("div", { className: "space-y-6", children: [
      /* @__PURE__ */ jsxs10("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx14(Typography11, { variant: "heading-XS", children: t("calendar_common:recent_searches") }),
        /* @__PURE__ */ jsx14(
          ThemeButton_default,
          {
            "data-testid": "header_search_clear_history",
            onClick: clearHistory,
            shape: "text",
            className: "py-1",
            children: /* @__PURE__ */ jsx14(Typography11, { variant: "label-S", children: t("calendar_common:clear_all") })
          }
        )
      ] }),
      /* @__PURE__ */ jsx14("ul", { className: "flex flex-wrap gap-2", children: searchHistory.map((term, i) => /* @__PURE__ */ jsx14("li", { children: /* @__PURE__ */ jsxs10(
        ThemeButton_default,
        {
          "data-testid": `header_search_history_button_${term}`,
          onClick: () => onSearch(term),
          theme: "white",
          shape: "outlined",
          className: "border-paper gap-2 p-2",
          children: [
            /* @__PURE__ */ jsx14(ArrowBackIcon, { className: "h-4 w-4 shrink-0" }),
            /* @__PURE__ */ jsx14(Typography11, { variant: "label-S", children: term })
          ]
        }
      ) }, i)) }),
      /* @__PURE__ */ jsx14(Divider2, {})
    ] }),
    /* @__PURE__ */ jsx14(FeaturedEvents_default, {})
  ] });
};
var InitialScreen_default = SearchInitialScreen;

// src/components/layout/header/search/desktop/Content.tsx
import { Fragment as Fragment6, jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var SearchContent = () => {
  const { events, search, searchState, isLoading, togglePopover } = useSearch();
  const { t } = useTranslation11("calendar_common");
  return /* @__PURE__ */ jsx15(Fragment6, { children: isLoading ? /* @__PURE__ */ jsxs11("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsx15("div", { className: "bg-body-level-1 h-20 rounded-md" }),
    /* @__PURE__ */ jsx15("div", { className: "bg-body-level-1 h-20 rounded-md" }),
    /* @__PURE__ */ jsx15("div", { className: "bg-body-level-1 h-20 rounded-md" })
  ] }) : !!searchState && (events == null ? void 0 : events.length) ? /* @__PURE__ */ jsxs11("div", { className: "space-y-4", children: [
    /* @__PURE__ */ jsx15(Typography12, { variant: "heading-XS", children: t("calendar_common:search_results_for", { search: searchState }) }),
    /* @__PURE__ */ jsx15("ul", { className: "space-y-4", children: events.map((event, i) => /* @__PURE__ */ jsx15(
      "li",
      {
        className: "flex items-center gap-2 [&>a>img]:min-h-20 [&>a>img]:min-w-20",
        children: /* @__PURE__ */ jsx15(ListItem_default, { event, onClick: () => togglePopover(false) })
      },
      event.slug + i
    )) })
  ] }) : search ? /* @__PURE__ */ jsx15(EmptyResult_default, {}) : /* @__PURE__ */ jsx15(InitialScreen_default, {}) });
};
var Content_default = SearchContent;

// src/components/layout/header/search/mobile/Category.tsx
import { ChevronIcon, FourSquares } from "@wbk/svg";
import { BottomSheet as BottomSheet2, Button as Button8, ToggleGroup as ToggleGroup2, Typography as Typography13 } from "@wbk/ui";
import { useRouter as useRouter9, useTranslation as useTranslation12 } from "@wbk/config";
import { jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
var SearchCategory = () => {
  const { t } = useTranslation12("calendar_common");
  const { category, setCategory } = useSearch();
  const { locale: lang } = useRouter9();
  const { data: categories } = useGetCategories({
    lang,
    limit: 20,
    where: { parent_exists: false }
  });
  return /* @__PURE__ */ jsx16(
    BottomSheet2,
    {
      ignoreHistory: true,
      sectionClassName: "pb-28 px-6",
      stickyFooter: ({ close }) => /* @__PURE__ */ jsxs12("div", { className: "bg-body-level-1 border-paper-level-1 flex gap-2 border-t px-6 py-4", children: [
        /* @__PURE__ */ jsx16(
          ThemeButton_default,
          {
            theme: "transparent",
            className: "h-12 flex-1",
            type: "button",
            onClick: () => {
              setCategory("");
              close();
            },
            children: t("calendar_common:clear")
          }
        ),
        /* @__PURE__ */ jsx16(ThemeButton_default, { className: "h-12 flex-1", onClick: close, children: t("calendar_common:apply") })
      ] }),
      body: () => /* @__PURE__ */ jsx16(Body2, { categories: categories || [] }),
      render: ({ open }) => {
        var _a;
        return /* @__PURE__ */ jsxs12(Button8, { theme: "action", onClick: open, className: "bg-body-dark/5 flex-1", rounded: false, children: [
          /* @__PURE__ */ jsx16(Typography13, { as: "span", variant: "body-S", className: "line-clamp-1", children: category ? (_a = categories == null ? void 0 : categories.find((c) => c.slug === category)) == null ? void 0 : _a.title : t("calendar_common:everything") }),
          /* @__PURE__ */ jsx16(ChevronIcon, { className: "h-2 w-2 rotate-90" })
        ] });
      }
    }
  );
};
var Body2 = ({ categories }) => {
  const { category, setCategory } = useSearch();
  const { t } = useTranslation12("calendar_common");
  return /* @__PURE__ */ jsx16(
    ToggleGroup2,
    {
      type: "single",
      value: category,
      onChange: setCategory,
      groupClassName: "flex-col",
      className: "w-full max-w-full justify-start text-start",
      btnProps: { theme: "primary" },
      options: [
        {
          text: t("calendar_common:everything"),
          value: "",
          icon: /* @__PURE__ */ jsx16(FourSquares, { className: "h-5 w-5" })
        }
      ].concat(
        categories.map((cat) => ({
          text: cat.title,
          value: cat.slug,
          icon: /* @__PURE__ */ jsx16(
            ContentfulMedia_default,
            {
              media: cat.icon,
              "data-selected": category === cat.slug,
              className: "h-5 w-5 data-[selected=true]:invert"
            }
          )
        }))
      )
    }
  );
};
var Category_default = SearchCategory;

// src/components/layout/header/search/mobile/Date.tsx
import { useMemo } from "react";
import { BottomSheet as BottomSheet3, Button as Button9, DayPicker, Typography as Typography14 } from "@wbk/ui";
import { formatDate as formatDate3, isSameDay } from "@wbk/utils";
import { useRouter as useRouter10, useTranslation as useTranslation13 } from "@wbk/config";
import { jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var SearchDate = () => {
  const { locale } = useRouter10();
  const { t } = useTranslation13("calendar_common");
  const { from, to, setDate } = useSearch();
  const date = useMemo(() => {
    if (from && to) {
      const sameDay = isSameDay(from, to);
      const formattedFrom = formatDate3(from, locale, {
        day: "2-digit",
        month: "short"
      });
      if (sameDay) {
        return formattedFrom;
      }
      const formattedTo = formatDate3(to, locale, {
        day: "2-digit",
        month: "short"
      });
      return `${formattedFrom} - ${formattedTo}`;
    }
    return t("calendar_common:any_time");
  }, [from, locale, t, to]);
  return /* @__PURE__ */ jsx17(
    BottomSheet3,
    {
      ignoreHistory: true,
      sectionClassName: "pb-28 px-6",
      stickyFooter: ({ close }) => /* @__PURE__ */ jsxs13("div", { className: "bg-body-level-1 border-paper-level-1 flex gap-2 border-t px-6 py-4", children: [
        /* @__PURE__ */ jsx17(
          ThemeButton_default,
          {
            theme: "transparent",
            className: "h-12 flex-1",
            type: "button",
            onClick: () => {
              setDate(void 0, void 0);
              close();
            },
            children: t("calendar_common:clear")
          }
        ),
        /* @__PURE__ */ jsx17(ThemeButton_default, { className: "h-12 flex-1", onClick: close, children: t("calendar_common:apply") })
      ] }),
      body: () => /* @__PURE__ */ jsx17(Body3, {}),
      render: ({ open }) => {
        return /* @__PURE__ */ jsx17(Button9, { onClick: open, className: "bg-body-dark/5 flex-1 rounded-none", theme: "action", children: /* @__PURE__ */ jsx17(Typography14, { as: "span", variant: "body-S", children: date }) });
      }
    }
  );
};
var Body3 = () => {
  const { from, to, setDate } = useSearch();
  const { locale } = useRouter10();
  return /* @__PURE__ */ jsx17(
    DayPicker,
    {
      lang: locale,
      mode: "range",
      selected: { from, to },
      fromDate: /* @__PURE__ */ new Date(),
      defaultMonth: from,
      onSelect: (value) => {
        setDate(value == null ? void 0 : value.from, value == null ? void 0 : value.to);
      },
      components: {
        CaptionLabel: ({ displayMonth }) => {
          return /* @__PURE__ */ jsx17(Typography14, { className: "px-2", children: formatDate3(displayMonth, locale, { month: "long", year: "numeric" }) });
        }
      }
    }
  );
};
var Date_default = SearchDate;

// src/components/layout/header/search/mobile/Content.tsx
import { Fragment as Fragment7, jsx as jsx18, jsxs as jsxs14 } from "react/jsx-runtime";
var MobileSearchContent = () => {
  const { t } = useTranslation14("calendar_common");
  const { push } = useRouter11();
  const { locale } = useRouter11();
  const { searchState, onSearch, togglePopover } = useSearch();
  return /* @__PURE__ */ jsxs14(Fragment7, { children: [
    /* @__PURE__ */ jsxs14("header", { className: "bg-body sticky top-0 z-10 shadow-sm", children: [
      /* @__PURE__ */ jsxs14("div", { className: "flex flex-row-reverse items-center gap-2 px-4 py-2", children: [
        /* @__PURE__ */ jsx18(
          "form",
          {
            className: "relative grow",
            onSubmit: (event) => {
              event.preventDefault();
              if (searchState == null ? void 0 : searchState.trim()) {
                togglePopover(false);
                push(`/${locale}/search?search=${searchState}`);
              }
            },
            children: /* @__PURE__ */ jsx18(
              Input,
              {
                "data-testid": "header_mobile_search_input",
                type: "search",
                inputMode: "search",
                className: "!bg-body h-12 ltr:pl-9 rtl:pr-9",
                placeholder: t("calendar_common:search"),
                value: searchState || "",
                onChange: (value) => onSearch(value),
                startIcon: /* @__PURE__ */ jsx18(SearchIcon2, { className: "mx-2 h-full w-6 shrink-0 opacity-70" })
              }
            )
          }
        ),
        /* @__PURE__ */ jsx18(
          Button10,
          {
            "data-testid": "header_mobile_close_search_button",
            theme: "action",
            onClick: () => togglePopover(false),
            className: "bg-body-dark/5 h-12 w-12 px-3 shadow-sm",
            children: /* @__PURE__ */ jsx18(ChevronIcon2, { className: "h-4 w-4 ltr:rotate-180" })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs14("div", { className: "flex", children: [
        /* @__PURE__ */ jsx18(Category_default, {}),
        /* @__PURE__ */ jsx18(Date_default, {})
      ] })
    ] }),
    /* @__PURE__ */ jsx18("div", { className: "p-4", children: /* @__PURE__ */ jsx18(Content_default, {}) })
  ] });
};
var Content_default2 = MobileSearchContent;

// src/components/layout/header/search/mobile/index.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var MobileSearch = () => {
  const { t } = useTranslation15("calendar_common");
  const { showPopover, togglePopover } = useSearch();
  const { isLessWidth } = useWindowResize({ width: 1279 });
  if (!isLessWidth) {
    return null;
  }
  return /* @__PURE__ */ jsx19(
    Modal,
    {
      fullscreen: true,
      ignoreHistory: true,
      unstyled: true,
      show: showPopover,
      onClose: () => togglePopover(false),
      className: "data-[state=open]:animate-in bg-body-level-1 data-[state=closed]:animate-out data-[state=closed]:slide-out-to-top-[45%] data-[state=open]:slide-in-from-top-[45%] fixed top-0 z-50 duration-1000",
      render: () => /* @__PURE__ */ jsx19(
        Button11,
        {
          shape: "text",
          theme: "secondary",
          className: "peer px-2",
          onClick: () => togglePopover(true),
          "data-testid": "mobile-search",
          "data-location": "header",
          "aria-label": t("calendar_common:search"),
          children: /* @__PURE__ */ jsx19(SearchIcon3, { className: "mx-auto h-6 w-6 shrink-0" })
        }
      ),
      body: () => /* @__PURE__ */ jsx19(Content_default2, {})
    }
  );
};
var mobile_default = MobileSearch;

// src/components/layout/header/NavigationItem.tsx
import { useRouter as useRouter12, useTranslation as useTranslation16 } from "@wbk/config";
import { Typography as Typography15 } from "@wbk/ui";
import { twMerge as twMerge5 } from "tailwind-merge";
import { jsx as jsx20, jsxs as jsxs15 } from "react/jsx-runtime";
var NavigationItem = (_a) => {
  var _b = _a, { as = "li", href, className, children } = _b, props = __objRest(_b, ["as", "href", "className", "children"]);
  const { pathname } = useRouter12();
  const { t } = useTranslation16("calendar_common");
  const { locale } = useRouter12();
  const isActive = (pathname == null ? void 0 : pathname.replace(`/${locale}`, "")) === (href == null ? void 0 : href.replace(`/${locale}`, ""));
  const isSoon = !href || href === "#";
  const Component = as;
  return /* @__PURE__ */ jsxs15(
    Component,
    __spreadProps(__spreadValues({
      "data-selected": isActive,
      "data-disabled": isSoon,
      className: twMerge5(
        "data-[selected=true]:text-body-dark text-body-dark hover:text-body-dark group relative shrink-0 transition",
        "[&_path]:data-[selected=true]:text-body-dark [&_path]:hover:text-body-dark lg:[&_path]:text-body-dark",
        "[&_path]:text-body-dark [&_path]:data-[selected=true]:text-body-dark",
        "data-[disabled=true]:text-text-disabled",
        className
      )
    }, props), {
      children: [
        isSoon && /* @__PURE__ */ jsx20(
          Typography15,
          {
            className: "absolute -translate-y-1/2 ltr:left-2 rtl:right-2",
            variant: "body-XS",
            color: "tertiary",
            children: t("calendar_common:soon")
          }
        ),
        typeof children === "function" ? children({ isActive, disabled: isSoon }) : children,
        /* @__PURE__ */ jsx20("div", { className: "bg-body-dark absolute bottom-0 left-1/2 h-0.5 w-0 max-w-20 -translate-x-1/2 transition-all peer-hover:w-1/2 peer-focus:w-1/2 peer-aria-disabled:hidden group-data-[selected=true]:w-1/2 peer-data-[selected=true]:w-1/2" })
      ]
    })
  );
};
var NavigationItem_default = NavigationItem;

// src/components/layout/header/submenu/index.tsx
import { jsx as jsx21, jsxs as jsxs16 } from "react/jsx-runtime";
var SubMenu = () => {
  const { t } = useTranslation17("calendar_common");
  const [open, setOpen] = useState5(false);
  const { pathname } = useRouter13();
  const isMap = pathname == null ? void 0 : pathname.includes("/map");
  const { locale } = useRouter13();
  return /* @__PURE__ */ jsxs16("ul", { className: "flex items-center", children: [
    !isMap && /* @__PURE__ */ jsx21(NavigationItem_default, { href: "!#", className: "block shrink-0 xl:hidden", children: /* @__PURE__ */ jsx21(mobile_default, {}) }),
    /* @__PURE__ */ jsx21(
      Popover2,
      {
        open,
        onOpenChange: setOpen,
        sideOffset: 35,
        alignOffset: -15,
        align: "end",
        className: "w-[420px] max-w-full",
        content: /* @__PURE__ */ jsx21(Weather_default, { onClick: () => setOpen(false) }),
        children: /* @__PURE__ */ jsx21("li", { children: /* @__PURE__ */ jsx21(NavigationItem_default, { as: "div", href: "/weather", className: "hidden shrink-0 lg:block", children: ({ isActive }) => /* @__PURE__ */ jsxs16(Button12, { shape: "text", className: "text-primary peer px-2", children: [
          /* @__PURE__ */ jsx21(Typography16, { variant: "label-M", className: "flex", children: /* @__PURE__ */ jsx21(Weather_default, { type: "degree" }) }),
          isActive ? /* @__PURE__ */ jsx21(WeatherIcon, { "data-active": isActive, className: "h-6 w-6 shrink-0" }) : /* @__PURE__ */ jsx21(WeatherOutlinedIcon, { "data-active": isActive, className: "h-6 w-6 shrink-0" })
        ] }) }) })
      }
    ),
    /* @__PURE__ */ jsx21(NavigationItem_default, { href: "/map", className: "hidden shrink-0 lg:block", children: ({ isActive }) => /* @__PURE__ */ jsx21(
      Button12,
      {
        as: Link6,
        href: `/${locale}/map`,
        shape: "text",
        className: "text-primary peer px-2",
        "aria-label": t("calendar_common:map"),
        children: isActive ? /* @__PURE__ */ jsx21(MapIcon, { "data-active": isActive, className: "h-6 w-6 shrink-0" }) : /* @__PURE__ */ jsx21(MapOutlinedIcon, { "data-active": isActive, className: "h-6 w-6 shrink-0" })
      }
    ) }),
    /* @__PURE__ */ jsx21(NavigationItem_default, { href: "/favorites", className: "shrink-0", children: ({ isActive }) => /* @__PURE__ */ jsx21(FavoritesNav_default, { isActive }) }),
    /* @__PURE__ */ jsx21(NavigationItem_default, { href: "!#", className: "shrink-0", children: /* @__PURE__ */ jsx21(LocalizationSwitcher_default, {}) })
  ] });
};
var submenu_default = SubMenu;

// src/components/layout/header/search/desktop/index.tsx
import { Input as Input2, Popover as Popover4 } from "@wbk/ui";
import { SearchIcon as SearchIcon4 } from "@wbk/svg";
import { useTranslation as useTranslation20 } from "@wbk/config";

// src/components/layout/header/search/desktop/Category.tsx
import { Button as Button13, Menu, Typography as Typography17 } from "@wbk/ui";
import { useRouter as useRouter14, useTranslation as useTranslation18 } from "@wbk/config";
import { ChevronIcon as ChevronIcon3, FourSquares as FourSquares2 } from "@wbk/svg";
import { jsx as jsx22, jsxs as jsxs17 } from "react/jsx-runtime";
var Category2 = () => {
  const { locale: lang } = useRouter14();
  const { t } = useTranslation18("calendar_common");
  const { category, setCategory } = useSearch();
  const { data: categories } = useGetCategories({
    lang,
    limit: 20,
    where: { parent_exists: false }
  });
  return /* @__PURE__ */ jsx22(
    Menu,
    {
      render: ({ open, selected }) => /* @__PURE__ */ jsxs17(Button13, { shape: "text", className: "px-1", onClick: open, children: [
        /* @__PURE__ */ jsx22(Typography17, { variant: "body-S", children: selected == null ? void 0 : selected.label }),
        /* @__PURE__ */ jsx22(ChevronIcon3, { className: "h-2 w-2 shrink-0 rotate-90" })
      ] }),
      item: { theme: "primary" },
      menu: { sideOffset: 35 },
      onChange: (value) => {
        setCategory(value == null ? void 0 : value.value);
      },
      value: category,
      options: [
        {
          label: t("calendar_common:everything"),
          text: /* @__PURE__ */ jsxs17("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx22(FourSquares2, { className: "h-5 w-5" }),
            /* @__PURE__ */ jsx22(Typography17, { variant: "body-S", children: t("calendar_common:everything") })
          ] }),
          value: ""
        },
        ...(categories == null ? void 0 : categories.map((category2) => ({
          label: category2.title,
          text: /* @__PURE__ */ jsxs17("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx22(ContentfulMedia_default, { media: category2.icon, className: "h-5 w-5" }),
            /* @__PURE__ */ jsx22(Typography17, { variant: "body-S", children: category2.title })
          ] }),
          value: category2.slug
        }))) || []
      ],
      hideErrorSpace: true
    }
  );
};
var Category_default2 = Category2;

// src/components/layout/header/search/desktop/Date.tsx
import { useMemo as useMemo2, useState as useState6 } from "react";
import { Button as Button14, DayPicker as DayPicker2, Divider as Divider3, Popover as Popover3, Typography as Typography18 } from "@wbk/ui";
import { dateAdd, endOfMonth, formatDate as formatDate4, isSameDay as isSameDay2 } from "@wbk/utils";
import { useRouter as useRouter15, useTranslation as useTranslation19 } from "@wbk/config";
import { ChevronIcon as ChevronIcon4 } from "@wbk/svg";
import { jsx as jsx23, jsxs as jsxs18 } from "react/jsx-runtime";
var DateSearch = () => {
  const [open, setOpen] = useState6(false);
  const { t } = useTranslation19("calendar_common");
  const { locale } = useRouter15();
  const { from, to, setDate } = useSearch();
  const today = /* @__PURE__ */ new Date();
  const tomorrow = dateAdd({ date: today, interval: "day", value: 1 });
  const weekStart = today;
  const weekEnd = dateAdd({ date: today, interval: "day", value: 6 });
  const monthStart = today;
  const monthEnd = endOfMonth(today);
  const isToday = from && to && isSameDay2(from, today) && isSameDay2(to, today);
  const isTomorrow = tomorrow && from && isSameDay2(from, tomorrow);
  const isWeek = from && to && isSameDay2(from, weekStart) && isSameDay2(to, weekEnd);
  const isMonth = from && to && isSameDay2(from, monthStart) && isSameDay2(to, monthEnd);
  const date = useMemo2(() => {
    if (from && to) {
      const sameDay = isSameDay2(from, to);
      const formattedFrom = formatDate4(from, locale, {
        day: "2-digit",
        month: "short"
      });
      if (sameDay) {
        return formattedFrom;
      }
      const formattedTo = formatDate4(to, locale, {
        day: "2-digit",
        month: "short"
      });
      return `${formattedFrom} - ${formattedTo}`;
    }
    return t("calendar_common:any_time");
  }, [from, locale, t, to]);
  return /* @__PURE__ */ jsx23(
    Popover3,
    {
      open,
      onOpenChange: setOpen,
      content: /* @__PURE__ */ jsxs18("div", { className: "!space-y-6", children: [
        /* @__PURE__ */ jsxs18("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx23(
            ThemeButton_default,
            {
              shape: isToday ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(today, today),
              children: t("calendar_common:date.today")
            }
          ),
          /* @__PURE__ */ jsx23(
            ThemeButton_default,
            {
              shape: isTomorrow ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(tomorrow, tomorrow),
              children: t("calendar_common:date.tomorrow")
            }
          ),
          /* @__PURE__ */ jsx23(
            ThemeButton_default,
            {
              shape: isWeek ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(weekStart, weekEnd),
              children: t("calendar_common:date.week")
            }
          ),
          /* @__PURE__ */ jsx23(
            ThemeButton_default,
            {
              shape: isMonth ? "solid" : "outlined",
              className: "border-paper",
              onClick: () => setDate(monthStart, monthEnd),
              children: t("calendar_common:date.month")
            }
          )
        ] }),
        /* @__PURE__ */ jsx23(
          DayPicker2,
          {
            mode: "range",
            selected: { from, to },
            fromDate: /* @__PURE__ */ new Date(),
            defaultMonth: from,
            numberOfMonths: 2,
            onSelect: (value) => {
              setDate(value == null ? void 0 : value.from, value == null ? void 0 : value.to);
            },
            components: {
              CaptionLabel: ({ displayMonth }) => {
                return /* @__PURE__ */ jsx23(Typography18, { className: "px-2", children: formatDate4(displayMonth, locale, { month: "long", year: "numeric" }) });
              }
            }
          }
        ),
        /* @__PURE__ */ jsx23(Divider3, {}),
        /* @__PURE__ */ jsxs18("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ jsx23(
            ThemeButton_default,
            {
              theme: "transparent",
              shape: "text",
              onClick: () => {
                setDate(void 0, void 0);
                setOpen(false);
              },
              children: t("calendar_common:clear")
            }
          ),
          /* @__PURE__ */ jsx23(ThemeButton_default, { onClick: () => setOpen(false), className: "min-w-24 p-3", children: t("calendar_common:done") })
        ] })
      ] }),
      className: "w-fit max-w-3xl",
      sideOffset: 35,
      children: /* @__PURE__ */ jsxs18(Button14, { shape: "text", className: "px-1", children: [
        /* @__PURE__ */ jsx23(Typography18, { variant: "body-S", children: date }),
        /* @__PURE__ */ jsx23(ChevronIcon4, { className: "h-2 w-2 shrink-0 rotate-90" })
      ] })
    }
  );
};
var Date_default2 = DateSearch;

// src/components/layout/header/search/desktop/index.tsx
import { jsx as jsx24, jsxs as jsxs19 } from "react/jsx-runtime";
var DesktopSearch = () => {
  const { t } = useTranslation20("calendar_common");
  const { events, showPopover, togglePopover, onSearch, total, searchState, onSubmit, clearAll } = useSearch();
  const { city } = useConfig_default();
  return /* @__PURE__ */ jsx24(
    Popover4,
    {
      content: /* @__PURE__ */ jsx24(Content_default, {}),
      cancel: !!searchState && (events == null ? void 0 : events.length) ? { theme: "primary", label: t("calendar_common:clear"), onClick: clearAll } : false,
      action: !!searchState && (events == null ? void 0 : events.length) ? {
        theme: "primary",
        label: t("calendar_common:show_all_results", { count: total }),
        onClick: onSubmit
      } : false,
      sideOffset: 35,
      onOpenAutoFocus: (e) => e.preventDefault(),
      onPointerDownOutside: () => {
        if (showPopover) {
          togglePopover(false);
        }
      },
      open: showPopover,
      children: /* @__PURE__ */ jsxs19(
        "form",
        {
          className: "relative mx-auto hidden grow overflow-hidden xl:block",
          onSubmit: (e) => {
            e.preventDefault();
            onSubmit();
          },
          children: [
            /* @__PURE__ */ jsx24(
              Input2,
              {
                autoComplete: "off",
                type: "search",
                name: "search",
                inputMode: "search",
                placeholder: t("calendar_common:search_in_city", { city: city.title }),
                groupClassName: "w-full",
                className: "bg-input/10 hover:bg-input/20 text-body-dark border-body-dark/10 focus:border-body-dark focus:bg-input/10 rounded-radius py-2.5",
                value: searchState,
                "data-testid": "home_search_input",
                onChange: (value) => {
                  if (!showPopover) {
                    togglePopover(true);
                  }
                  onSearch(value);
                },
                onFocus: () => {
                  togglePopover(true);
                }
              }
            ),
            /* @__PURE__ */ jsxs19("div", { className: "absolute top-1/2 flex -translate-y-1/2 items-center gap-2 ltr:right-2 rtl:left-2", children: [
              /* @__PURE__ */ jsx24(Date_default2, {}),
              /* @__PURE__ */ jsx24(Category_default2, {}),
              /* @__PURE__ */ jsxs19(
                ThemeButton_default,
                {
                  type: "submit",
                  "aria-label": "Search",
                  className: "items-center justify-center p-2 text-sm",
                  children: [
                    /* @__PURE__ */ jsx24("span", { className: "3xl:block hidden", children: t("calendar_common:search") }),
                    /* @__PURE__ */ jsx24(SearchIcon4, { className: "3xl:hidden block h-5 w-5 shrink-0" })
                  ]
                }
              )
            ] })
          ]
        }
      )
    }
  );
};
var desktop_default = DesktopSearch;

// src/components/layout/header/Desktop.tsx
import { jsx as jsx25, jsxs as jsxs20 } from "react/jsx-runtime";
var DesktopHeader = ({ config }) => {
  const { locale, pathname } = useRouter16();
  const isHome = (pathname == null ? void 0 : pathname.replace(locale, "")) === "/";
  const isMap = pathname == null ? void 0 : pathname.includes("/map");
  const { y } = useWindowScroll();
  return /* @__PURE__ */ jsx25(
    "header",
    {
      "data-sticky": y >= 40,
      "data-home": isHome,
      className: twMerge6(
        "bg-body group z-20 hidden h-20 w-full content-center transition-all lg:block",
        isHome ? "data-[sticky=false]:rounded-radius relative top-10 mx-auto -mb-20 data-[sticky=true]:sticky data-[sticky=true]:top-0 data-[sticky=true]:h-24 data-[sticky=false]:max-w-[calc(min(95%,1440px))] data-[sticky=true]:max-w-full data-[sticky=true]:rounded-none data-[sticky=true]:shadow-md" : "sticky top-0"
      ),
      children: /* @__PURE__ */ jsxs20("nav", { className: twMerge6("container flex items-center gap-6", isMap && "justify-between"), children: [
        /* @__PURE__ */ jsxs20("div", { className: "flex grow items-center gap-6 xl:grow-0", children: [
          /* @__PURE__ */ jsx25(
            Link7,
            {
              to: `/${locale}`,
              className: "relative block h-12 shrink-0 hover:opacity-90",
              "data-location": "header",
              children: /* @__PURE__ */ jsx25(
                ContentfulMedia_default,
                {
                  media: config.logo,
                  className: "h-full object-contain",
                  alt: config.title
                }
              )
            }
          ),
          /* @__PURE__ */ jsx25("ul", { className: "hidden items-center gap-1 lg:flex", children: config.header.navigationCollection.items.map((button) => {
            if (!button)
              return null;
            return /* @__PURE__ */ jsx25(NavigationItem_default, { href: button.href, children: ({ disabled }) => /* @__PURE__ */ jsx25(
              ContentfulButton_default,
              {
                className: "text-body-M font-label peer whitespace-nowrap px-2 aria-disabled:bg-transparent",
                shape: button.shape,
                theme: button.theme,
                button,
                "data-location": "header",
                "data-category": button.label,
                "aria-disabled": disabled,
                disabled
              }
            ) }, button.id);
          }) })
        ] }),
        !isMap && /* @__PURE__ */ jsx25(desktop_default, {}),
        /* @__PURE__ */ jsx25(submenu_default, {})
      ] })
    }
  );
};
var Desktop_default = DesktopHeader;

// src/components/layout/header/Mobile.tsx
import { useCycle } from "motion/react";
import { useWindowScroll as useWindowScroll2 } from "@wbk/hooks";
import { twMerge as twMerge7 } from "tailwind-merge";
import { Link as Link9, useRouter as useRouter19 } from "@wbk/config";

// src/components/layout/header/SideMenu.tsx
import { AnimatePresence as AnimatePresence2, motion as motion2 } from "motion/react";
import { Link as Link8, useRouter as useRouter18 } from "@wbk/config";

// src/components/layout/header/MenuButton.tsx
import { AnimatePresence, motion } from "motion/react";
import { useRouter as useRouter17 } from "@wbk/config";
import { Button as Button15 } from "@wbk/ui";
import { jsx as jsx26, jsxs as jsxs21 } from "react/jsx-runtime";
var MenuButton = ({ isOpen, toggleOpen }) => {
  const { locale } = useRouter17();
  return /* @__PURE__ */ jsx26(
    Button15,
    {
      shape: "text",
      className: "z-30 h-6 w-6 flex-col p-0",
      theme: "secondary",
      onClick: () => toggleOpen(),
      "aria-label": isOpen ? "Close Mobile Menu" : "Open Mobile Menu",
      children: /* @__PURE__ */ jsxs21(AnimatePresence, { mode: "popLayout", children: [
        /* @__PURE__ */ jsx26(
          motion.div,
          {
            initial: { rotateZ: 0, x: 0 },
            animate: {
              rotateZ: isOpen ? -45 : 0,
              y: isOpen ? "150%" : 0
            },
            className: "bg-body-dark h-0.5 w-5 rounded-full"
          },
          1
        ),
        !isOpen && /* @__PURE__ */ jsx26(
          motion.div,
          {
            className: "bg-body-dark h-0.5 w-5 rounded-full",
            initial: { x: locale === "ar" ? "100%" : "-100%", opacity: 0 },
            animate: { x: 0, opacity: 1 },
            exit: { x: locale === "ar" ? "100%" : "-100%", opacity: 0 }
          },
          2
        ),
        /* @__PURE__ */ jsx26(
          motion.div,
          {
            initial: { rotateZ: 0 },
            animate: {
              rotateZ: isOpen ? 45 : 0,
              y: isOpen ? "-150%" : 0
            },
            className: "bg-body-dark h-0.5 w-5 rounded-full"
          },
          3
        )
      ] })
    }
  );
};
var MenuButton_default = MenuButton;

// src/components/layout/header/SideMenu.tsx
import { Fragment as Fragment8, jsx as jsx27, jsxs as jsxs22 } from "react/jsx-runtime";
var SideMenu = ({ config, isOpen, toggleOpen }) => {
  const { locale } = useRouter18();
  return /* @__PURE__ */ jsxs22(Fragment8, { children: [
    isOpen && /* @__PURE__ */ jsx27("style", { children: "body{overflow:hidden}" }),
    /* @__PURE__ */ jsx27(AnimatePresence2, { children: isOpen && /* @__PURE__ */ jsx27(
      motion2.div,
      {
        onClick: () => toggleOpen(),
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        className: "bg-body-dark/50 fixed inset-0 z-[9999] backdrop-blur-lg"
      },
      "backdrop"
    ) }),
    /* @__PURE__ */ jsxs22(
      motion2.nav,
      {
        className: "mini-scrollbar bg-body text-body-dark group fixed top-0 z-[9999] h-full max-h-svh w-full overflow-x-hidden ltr:left-0 rtl:right-0",
        initial: "closed",
        animate: isOpen ? "open" : "closed",
        variants: {
          open: { width: "100%", maxWidth: 450 },
          closed: { width: 0, maxWidth: 450 }
        },
        children: [
          /* @__PURE__ */ jsxs22("div", { className: "border-paper sticky inset-x-0 top-0 flex h-20 items-center justify-between gap-5 border-l px-4 backdrop-blur-xl", children: [
            /* @__PURE__ */ jsx27(MenuButton_default, { isOpen, toggleOpen }),
            /* @__PURE__ */ jsx27(
              Link8,
              {
                to: `/${locale}`,
                className: "relative z-30 block h-12 shrink-0 hover:opacity-90",
                "data-location": "header",
                children: /* @__PURE__ */ jsx27(
                  ContentfulMedia_default,
                  {
                    media: config.logo,
                    className: "h-full object-contain",
                    alt: config.title
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ jsxs22("div", { className: "divide-paper relative w-full divide-y px-4 pb-16", children: [
            /* @__PURE__ */ jsx27("ul", { className: "space-y-2 py-4", role: "menu", children: config.header.navigationCollection.items.map((button) => {
              if (!button)
                return null;
              return /* @__PURE__ */ jsx27(
                NavigationItem_default,
                {
                  href: button.href,
                  className: "w-fit",
                  role: "menuitem",
                  children: ({ disabled }) => /* @__PURE__ */ jsx27(
                    ContentfulButton_default,
                    {
                      className: "text-body-M font-label peer whitespace-nowrap px-2 aria-disabled:bg-transparent",
                      shape: button.shape,
                      theme: button.theme,
                      button,
                      "data-location": "header",
                      "data-category": button.label,
                      "aria-disabled": disabled,
                      disabled,
                      onClick: () => toggleOpen()
                    }
                  )
                },
                button.id
              );
            }) }),
            /* @__PURE__ */ jsx27(Weather_default, { className: "whitespace-nowrap", onClick: () => toggleOpen() })
          ] })
        ]
      }
    )
  ] });
};
var SideMenu_default = SideMenu;

// src/components/layout/header/Mobile.tsx
import { Fragment as Fragment9, jsx as jsx28, jsxs as jsxs23 } from "react/jsx-runtime";
var MobileHeader = ({ config }) => {
  const { locale, pathname } = useRouter19();
  const isHome = (pathname == null ? void 0 : pathname.replace(locale, "")) === "/";
  const { y } = useWindowScroll2();
  const [isOpen, toggleOpen] = useCycle(false, true);
  return /* @__PURE__ */ jsxs23(Fragment9, { children: [
    /* @__PURE__ */ jsx28(SideMenu_default, { config, isOpen, toggleOpen }),
    /* @__PURE__ */ jsx28(
      "header",
      {
        "data-sticky": y >= 20,
        "data-home": isHome,
        className: twMerge7(
          "bg-body group z-20 block w-full content-center py-4 transition-all lg:hidden",
          isHome ? "data-[sticky=false]:rounded-radius relative top-6 mx-auto -mb-20 h-12 data-[sticky=true]:sticky data-[sticky=true]:top-0 data-[sticky=true]:h-24 data-[sticky=false]:max-w-[calc(min(95%,1440px))] data-[sticky=true]:max-w-full data-[sticky=true]:rounded-none data-[sticky=false]:py-1 data-[sticky=true]:shadow-md" : "sticky top-0"
        ),
        children: /* @__PURE__ */ jsxs23("nav", { className: "container flex items-center gap-6", children: [
          /* @__PURE__ */ jsxs23("div", { className: "flex grow items-center gap-2", children: [
            /* @__PURE__ */ jsx28(MenuButton_default, { isOpen, toggleOpen }),
            /* @__PURE__ */ jsx28(
              Link9,
              {
                to: `/${locale}`,
                className: "relative z-30 block h-12 shrink-0 hover:opacity-90 group-data-[home=true]:group-data-[sticky=false]:h-9",
                "data-location": "header",
                children: /* @__PURE__ */ jsx28(
                  ContentfulMedia_default,
                  {
                    media: config.logo,
                    className: "h-full object-contain",
                    alt: config.title
                  }
                )
              }
            )
          ] }),
          /* @__PURE__ */ jsx28(submenu_default, {})
        ] })
      }
    )
  ] });
};
var Mobile_default = MobileHeader;

// src/components/layout/header/index.tsx
import { jsx as jsx29, jsxs as jsxs24 } from "react/jsx-runtime";
var Header = ({ config }) => {
  return /* @__PURE__ */ jsxs24(provider_default, { children: [
    /* @__PURE__ */ jsx29(Desktop_default, { config }),
    /* @__PURE__ */ jsx29(Mobile_default, { config })
  ] });
};
var header_default = Header;

// src/components/layout/footer/index.tsx
import { Button as Button16, Typography as Typography21 } from "@wbk/ui";
import { WorldIcon as WorldIcon2 } from "@wbk/svg";
import { useRouter as useRouter20, useTranslation as useTranslation21 } from "@wbk/config";
import { useCurrency as useCurrency2 } from "@wbk/currency";

// src/components/layout/footer/Copyright.tsx
import { Typography as Typography19 } from "@wbk/ui";
import { jsx as jsx30 } from "react/jsx-runtime";
var Copyright = ({ text }) => {
  if (!text)
    return null;
  return /* @__PURE__ */ jsx30(Typography19, { color: "text-secondary", children: text });
};
var Copyright_default = Copyright;

// src/components/layout/footer/VisitCity.tsx
import { Typography as Typography20 } from "@wbk/ui";
import { jsx as jsx31, jsxs as jsxs25 } from "react/jsx-runtime";
var VisitCity = ({ section }) => {
  var _a;
  const cards = (_a = section == null ? void 0 : section.contentCollection) == null ? void 0 : _a.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  const color = section.titleColor;
  return /* @__PURE__ */ jsxs25(DecoratedSection_default, { section, className: "border-paper space-y-12", children: [
    /* @__PURE__ */ jsxs25("div", { className: "relative z-10 space-y-2", children: [
      /* @__PURE__ */ jsx31(Typography20, { as: "h2", variant: "heading-XXL", children: section.title }),
      section.subtitle && /* @__PURE__ */ jsx31(Typography20, { variant: "body-L", children: section.subtitle })
    ] }),
    /* @__PURE__ */ jsx31("ul", { className: "grid grid-cols-1 gap-6 md:grid-cols-4", children: cards.map((card, index) => {
      return /* @__PURE__ */ jsx31("li", { "data-border": index % 4 !== 0, className: "space-y-2", children: /* @__PURE__ */ jsx31(
        IconItem_default,
        {
          className: "bg-body-light/20 disabled:bg-body-light/10 hover:bg-body-light/30 active:bg-body-light/20 block h-full w-full py-4 text-start",
          card,
          btnProps: { style: { color } }
        }
      ) }, card.id);
    }) })
  ] });
};
var VisitCity_default = VisitCity;

// src/components/layout/footer/index.tsx
import { Fragment as Fragment10, jsx as jsx32, jsxs as jsxs26 } from "react/jsx-runtime";
var Footer = ({ config }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation21("calendar_common");
  const { locale } = useRouter20();
  const { currency } = useCurrency2();
  return /* @__PURE__ */ jsx32(Fragment10, { children: /* @__PURE__ */ jsxs26("footer", { className: "border-paper group/footer border-t", children: [
    /* @__PURE__ */ jsx32(VisitCity_default, { section: config.footer.visitCity }),
    /* @__PURE__ */ jsxs26("div", { className: "container space-y-4", children: [
      /* @__PURE__ */ jsxs26("div", { className: "flex flex-col items-center justify-center gap-6 md:flex-row md:justify-between", children: [
        /* @__PURE__ */ jsxs26("div", { className: "flex flex-col items-center gap-6 md:flex-row", children: [
          config.logo && /* @__PURE__ */ jsx32("figure", { className: "block shrink-0", children: /* @__PURE__ */ jsx32(
            ContentfulMedia_default,
            {
              className: "aspect-1 object-contain",
              media: config.logo,
              width: 80,
              height: 80
            }
          ) }),
          /* @__PURE__ */ jsx32("ul", { className: "flex shrink-0 items-center gap-3", children: (_b = (_a = config.socialLinks) == null ? void 0 : _a.iconsCollection) == null ? void 0 : _b.items.map((link) => /* @__PURE__ */ jsx32("li", { className: "rounded-md", children: /* @__PURE__ */ jsx32(
            ContentfulButton_default,
            {
              button: link,
              rel: "noreferrer noopener",
              className: "social_media_follow overflow-hidden rounded-md !p-1",
              "data-location": "footer",
              "data-category": link.label,
              shape: link.shape,
              theme: link.theme
            }
          ) }, link.id)) })
        ] }),
        /* @__PURE__ */ jsx32(
          LocalizationSwitcher_default,
          {
            render: ({ open }) => /* @__PURE__ */ jsxs26(Button16, { shape: "outlined", onClick: open, arrow: true, children: [
              /* @__PURE__ */ jsx32(WorldIcon2, { className: "h-5 w-5 shrink-0" }),
              /* @__PURE__ */ jsx32(Typography21, { children: `${t(`common:${locale}`)} | ${currency.name}` })
            ] })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs26("div", { className: "flex flex-wrap items-center justify-center gap-2 border-t py-4 md:gap-6", children: [
        /* @__PURE__ */ jsx32(Copyright_default, { text: config.footer.copyrightText }),
        ((_d = (_c = config.footer.navigationCollection) == null ? void 0 : _c.items) == null ? void 0 : _d.length) > 0 && /* @__PURE__ */ jsx32("ul", { className: "flex items-center gap-2", children: config.footer.navigationCollection.items.map((link) => {
          if (!link)
            return;
          return /* @__PURE__ */ jsx32("li", { children: /* @__PURE__ */ jsx32(
            ContentfulButton_default,
            {
              button: link,
              rel: "noreferrer noopener",
              "data-location": "footer",
              "data-category": link.label,
              className: "p-1 underline-offset-2 hover:underline",
              shape: link.shape
            }
          ) }, link.id);
        }) })
      ] })
    ] })
  ] }) });
};
var footer_default = Footer;

// src/components/layout/Layout.tsx
import { jsx as jsx33, jsxs as jsxs27 } from "react/jsx-runtime";
var Layout = ({ footer = "default", children }) => {
  const { locale, pathname } = useRouter21();
  const { config, isLoading } = useConfig_default();
  const isHome = (pathname == null ? void 0 : pathname.replace(locale, "")) === "/";
  return /* @__PURE__ */ jsxs27(Fragment11, { children: [
    isLoading && !isHome ? /* @__PURE__ */ jsx33("header", { className: "bg-body h-20 w-full" }) : config ? /* @__PURE__ */ jsx33(header_default, { config }) : null,
    /* @__PURE__ */ jsx33("main", { id: "main", children }),
    footer === "default" && /* @__PURE__ */ jsx33(Suspense, { children: !!config && /* @__PURE__ */ jsx33(footer_default, { config }) })
  ] });
};
var Layout_default = Layout;

export {
  provider_default,
  Info_default,
  provider_default2,
  ListItem_default,
  Layout_default
};
//# sourceMappingURL=chunk-7KKOELSM.mjs.map